export default "__VITE_ASSET__EAtbYFTI__"